import { Autocomplete, Box, FormControlLabel, Radio, RadioGroup, TextField, Typography, MenuItem } from '@mui/material';
import React, { useState, useRef, useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import SearchInput from '../../Components/SearchInput';
import unitAPI from '../../Network/Unit';
import mizanUnitAPI from '../../Network/MizanUnit';
import geofenceAPI from '../../Network/Geofence';
import routeAPI from '../../Network/Route';
import mizanListAPI from '../../Network/MizanList';
import Cookies from "universal-cookie";
import moment from 'moment/moment';
import CustomDateRange from '../../Components/CustomDateRange';
import userAPI from '../../Network/User';
const cookies = new Cookies();

// Stable default so the memoized Gate below doesn't change identity each render
// for pages that don't pass an isVisible prop (a new () => true each render would
// remount every wrapped filter on every keystroke).
const ALWAYS_VISIBLE = () => true;

const Search = ({
  filters,
  setFilters,
  loadingBranches,
  branches,
  portCategories,
  loadingPortCategories,
  groups,
  loadingGroups,
  loadingTransactionStatuses,
  loadingUsers,
  users,
  transactionStatuses,
  transactionType2List,
  loadingTransactionType2List,
  noUnits,
  showType,
  showUnitTransactionType,
  loadingTransactionProductTypes,
  transactionProductTypes,
  municipalities,
  loadingMunicipalities,
  isInternal = false, // Pass isInternal prop
  showWeightRange = false, // net-weight range filter — only the custom/internal pages opt in
  isVisible = ALWAYS_VISIBLE // per-filter visibility resolver, owned by the page (useFilterVisibility)
}) => {
  const [t] = useTranslation("common");
  // <Gate name="key"> hides a filter when the page's isVisible(key) is false.
  // MEMOIZED so its identity is stable across renders — otherwise a new Gate
  // component each render remounts every wrapped filter on every keystroke
  // (clearing search inputs / killing focus). isVisible is stable (useCallback).
  const Gate = React.useMemo(
    () => ({ name, children }) => (isVisible(name) ? children : null),
    [isVisible]
  );
  const timerUnits = useRef(null)
  const timerSourceGeofences = useRef(null)
  const timerHostingSourceGeofences = useRef(null)
  const timerDestinationGeofences = useRef(null)
  const timerRoutes = useRef(null)
  const timerAccounts = useRef(null)

  const [units, setUnits] = useState([])
  const [sourceGeofences, setSourceGeofences] = useState([])
  const [hostingSourceGeofences, setHostingSourceGeofences] = useState([])
  const [destinationGeofences, setDestinationGeofences] = useState([])
  const [routes, setRoutes] = useState([])
  const [accounts, setAccounts] = useState([])

  const [loadingAccounts, setLoadingAccounts] = useState(true)
  const [loadingUnits, setLoadingUnits] = useState(false)
  const [loadingSourceGeofences, setLoadingSourceGeofences] = useState(false)
  const [loadingDestinationGeofences, setLoadingDestinationGeofences] = useState(false)
  const [loadingHostingSourceGeofences, setLoadingHostingSourceGeofences] = useState(false)
  const [loadingRoutes, setLoadingRoutes] = useState(false)

  const [lookups, setLookups] = useState({
    mizans: [],
    belongings: []
  })
  const [loadingLookups, setLoadingLookups] = useState(true)


  const [searchTermUnit, setSearchTermUnit] = useState("");
  const [searchTermSourceGeofence, setSearchTermSourceGeofence] = useState("");
  const [searchTermHostingSourceGeofence, setSearchTermHostingSourceGeofence] = useState("");
  const [searchTermDestinationGeofence, setSearchTermDestinationGeofence] = useState("");
  const [searchTermAccount, setSearchTermAccount] = useState("");
  const [searchTermRoute, setSearchTermRoute] = useState("");

  const headerObject = {
    username: cookies.get("user_name") ? cookies.get("user_name") : null,
    user_id: cookies.get("user_id") ? cookies.get("user_id") : null,
    account_name: cookies.get("account_name") ? cookies.get("account_name") : null,
    account_id: cookies.get("account_id") ? cookies.get("account_id") : null,
    authHash: cookies.get("authHash") ? cookies.get("authHash") : null,
    sid: cookies.get("sid") ? cookies.get("sid") : null,
    baseurl: cookies.get("baseUrl") ? cookies.get("baseUrl") : null,
    id: cookies.get("id") ? cookies.get("id") : null,
  }

  const handleSearchTermUnitChange = (newValue) => {


    setSearchTermUnit(newValue);
    if (timerUnits.current) {
      clearTimeout(timerUnits?.current)
    }
    timerUnits.current = setTimeout(async () => {
      if (newValue?.length >= 3) {
        setLoadingUnits(true);

        const result = await unitAPI.getUnitList({
          params: {
            ...headerObject,
            name: newValue,
            page_size: 20,
            page: 1
          }

        })
        setLoadingUnits(false);

        if (result.status && result?.data?.data?.data) {
          setUnits(result?.data?.data?.data)
        }
      }
      else {
        setUnits([])
      }
    }, 1000)
  };



  const handleSearchTermSourceGeofenceChange = (newValue) => {

    setSearchTermSourceGeofence(newValue);
    if (timerSourceGeofences.current) {
      clearTimeout(timerSourceGeofences?.current)
    }
    timerSourceGeofences.current = setTimeout(async () => {
      if (newValue?.length >= 3) {
        setLoadingSourceGeofences(true);

        const result = await geofenceAPI.getGeofenceList({
          params: {
            ...headerObject,
            name: newValue,
            port_type_ids: [1, 3],
            page_size: 40,
            page: 1
          }

        })
        setLoadingSourceGeofences(false);

        if (result.status && result?.data?.data?.data) {
          setSourceGeofences(result?.data?.data?.data)
        }
      }
      else {
        setSourceGeofences([])
      }
    }, 1000)
  };

  const handleSearchTermHostingSourceGeofenceChange = (newValue) => {

    setSearchTermHostingSourceGeofence(newValue);
    if (timerHostingSourceGeofences.current) {
      clearTimeout(timerHostingSourceGeofences?.current)
    }
    timerHostingSourceGeofences.current = setTimeout(async () => {
      if (newValue?.length >= 3) {
        setLoadingHostingSourceGeofences(true);

        const result = await geofenceAPI.getGeofenceList({
          params: {
            ...headerObject,
            name: newValue,
            port_type_ids: [1, 3],
            page_size: 20,
            page: 1
          }

        })
        setLoadingHostingSourceGeofences(false);

        if (result.status && result?.data?.data?.data) {
          setHostingSourceGeofences(result?.data?.data?.data)
        }
      }
      else {
        setHostingSourceGeofences([])
      }
    }, 1000)
  };

  const handleSearchTermDestinationGeofenceChange = (newValue) => {

    setSearchTermDestinationGeofence(newValue);
    if (timerDestinationGeofences.current) {
      clearTimeout(timerDestinationGeofences?.current)
    }
    timerDestinationGeofences.current = setTimeout(async () => {
      if (newValue?.length >= 3) {
        setLoadingDestinationGeofences(true);

        const result = await geofenceAPI.getGeofenceList({
          params: {
            ...headerObject,
            name: newValue,
            port_type_ids: [2, 3],
            page_size: 20,
            page: 1
          }

        })
        setLoadingDestinationGeofences(false);

        if (result.status && result?.data?.data?.data) {
          setDestinationGeofences(result?.data?.data?.data)
        }
      }
      else {
        setDestinationGeofences([])
      }
    }, 1000)
  };
  const handleSearchTermAccountChange = (newValue) => {

    setSearchTermAccount(newValue);
    if (timerAccounts.current) {
      clearTimeout(timerAccounts?.current)
    }
    timerAccounts.current = setTimeout(async () => {
      if (newValue?.length >= 3) {
        setLoadingAccounts(true);

        const result = await userAPI.getAccounts({
          params: {
            ...headerObject,
            name: newValue,
            page_size: 20,
            page: 1
          }

        })
        setLoadingAccounts(false);

        if (result.status && result?.data?.data?.data) {
          setAccounts(result?.data?.data?.data)
        }
      }
      else {
        setAccounts([])
      }
    }, 1000)
  };

  const handleSearchTermRouteChange = (newValue) => {

    setSearchTermRoute(newValue);
    if (timerRoutes.current) {
      clearTimeout(timerRoutes?.current)
    }
    timerRoutes.current = setTimeout(async () => {
      if (newValue?.length >= 3) {
        setLoadingRoutes(true);

        const result = await routeAPI.getRouteList({
          params: {
            ...headerObject,
            name: newValue,
            page_size: 20,
            page: 1
          }

        })
        setLoadingRoutes(false);

        if (result.status && result?.data?.data?.data) {
          setRoutes(result?.data?.data?.data)
        }
      }
      else {
        setRoutes([])
      }
    }, 1000)
  };

  useEffect(() => {
    loadSourceGeofences()
    loadHostingSourceGeofences()
    loadDestinationGeofences()
    loadLookups()
  }, []);

  const loadLookups = async () => {
    try {
      const result = await mizanUnitAPI.getLookups({
        params: headerObject,
      });

      if (result.status && result?.data?.data) {
        let lookupsData = result.data.data;
        
        // Fetch specific mizan lookup with only names
        const mizanResult = await mizanListAPI.getMizanLookup({
          params: headerObject,
        });
        
        if (mizanResult.status && mizanResult?.data?.data) {
          lookupsData.mizans = mizanResult.data.data;
        }
        
        setLookups(lookupsData);
      }
    } catch (error) {
      console.error('Error loading lookups:', error);
    } finally {
      setLoadingLookups(false);
    }
  };
  const loadHostingSourceGeofences = async () => {
    setLoadingHostingSourceGeofences(true);

    const result = await geofenceAPI.getGeofenceList({
      params: {
        ...headerObject,
        port_type_ids: [1, 3],
        page_size: 40,
        page: 1
      }

    })
    setLoadingHostingSourceGeofences(false);

    if (result.status && result?.data?.data?.data) {
      setHostingSourceGeofences(result?.data?.data?.data)
    }

    else {
      setHostingSourceGeofences([])
    }
  }

  const loadSourceGeofences = async () => {
    setLoadingSourceGeofences(true);

    const result = await geofenceAPI.getGeofenceList({
      params: {
        ...headerObject,

        port_type_ids: [1, 3],
        page_size: 40,
        page: 1
      }

    })
    setLoadingSourceGeofences(false);

    if (result.status && result?.data?.data?.data) {
      setSourceGeofences(result?.data?.data?.data)
    }

    else {
      setSourceGeofences([])
    }
  }

  const loadDestinationGeofences = async () => {
    setLoadingDestinationGeofences(true);

    const result = await geofenceAPI.getGeofenceList({
      params: {
        ...headerObject,
        port_type_ids: [2, 3],
        page_size: 20,
        page: 1
      }

    })
    setLoadingDestinationGeofences(false);

    if (result.status && result?.data?.data?.data) {
      setDestinationGeofences(result?.data?.data?.data)
    }

    else {
      setDestinationGeofences([])
    }
  }
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        width: "100% !important",
      }}
    >
      {(showUnitTransactionType || noUnits) ? null :
        <>
          <Gate name="unit"><Autocomplete
            sx={{
              ml: 1.5, mt: 1, mb: 1, width: '95%',
              '& .MuiFormLabel-root,& .MuiInputBase-input': {
                fontFamily: 'Cairo-Medium'
              }
            }}
            onInputChange={(event, newInputValue) => {

              handleSearchTermUnitChange(newInputValue);
            }}
            inputValue={searchTermUnit}
            loading={loadingUnits}
            isOptionEqualToValue={(option, value) => option?.id == value?.id}
            loadingText={t('GLOBAL.searching')}
            value={filters?.unit}
            options={filters?.unit && !units.find(u => u.id == filters.unit.id) ? [filters.unit, ...units] : units}
            getOptionLabel={(option) => {

              return option && option?.name || ""
            }}
            onChange={(e, v, r) => {

              setFilters({
                ...filters,
                unit: v,
                unit_id: v ? v?.id : ""
              })
            }}
            renderInput={(params) => (
              <TextField {...params}
                placeholder={t('TRANSACTIONS.unit')}
                variant="standard" sx={{ fontFamily: 'Cairo-Medium' }} />
            )}
          /></Gate>
          <Gate name="account"><Autocomplete
            sx={{
              ml: 1.5, mt: 1, mb: 1, width: '95%',
              '& .MuiFormLabel-root,& .MuiInputBase-input': {
                fontFamily: 'Cairo-Medium'
              }
            }}
            onInputChange={(event, newInputValue) => {

              handleSearchTermAccountChange(newInputValue);
            }}
            inputValue={searchTermAccount}
            loading={loadingAccounts}
            isOptionEqualToValue={(option, value) => option?.id == value?.id}
            loadingText={t('GLOBAL.searching')}
            value={filters?.account}
            options={filters?.account && !accounts.find(a => a.id == filters.account.id) ? [filters.account, ...accounts] : accounts}

            getOptionLabel={(option) => {

              return option && option?.name || ""
            }}


            onChange={(e, v, r) => {

              setFilters({
                ...filters,
                account: v,
                unit_account_id: v ? v?.id : ""
              })
            }}
            renderInput={(params) => (
              <TextField {...params}
                placeholder={t('UNITS.account_name')}
                variant="standard" sx={{ fontFamily: 'Cairo-Medium' }} />
            )}
          /></Gate>
          <Gate name="is_governmental"><TextField
            select
            fullWidth
            variant="standard"
            size="small"
            label={"نوع الجهد"}
            value={filters.is_governmental ?? ""}
            onChange={(e) => setFilters({ ...filters, is_governmental: e.target.value === "" ? null : e.target.value })}
            sx={{
              ml: 1.5, mt: 1, mb: 1, width: '95%',
              '& .MuiInputLabel-root': { fontFamily: 'Cairo-Medium' },
              '& .MuiInputBase-input': { fontFamily: 'Cairo-Medium' }
            }}
            SelectProps={{
              native: false,
              MenuProps: {
                PaperProps: {
                  sx: {
                    '& .MuiMenuItem-root': {
                      fontFamily: 'Cairo-Medium',
                    },
                  },
                },
              },
            }}
          >
            <MenuItem value="" sx={{ fontFamily: 'Cairo-Medium' }}>{"الكل"}</MenuItem>
            <MenuItem value="1" sx={{ fontFamily: 'Cairo-Medium' }}>{"ذاتي"}</MenuItem>
            <MenuItem value="0" sx={{ fontFamily: 'Cairo-Medium' }}>{"مؤجر"}</MenuItem>
          </TextField></Gate>
          <Gate name="municipality"><Autocomplete
            sx={{
              ml: 1.5, mt: 1, mb: 1, width: '95%',
              '& .MuiFormLabel-root,& .MuiInputBase-input': {
                fontFamily: 'Cairo-Medium'
              }
            }}
            value={filters?.municipality}
            options={filters?.municipality && !(municipalities || []).find(m => (m.id || m.MunicipalityId) == (filters.municipality.id || filters.municipality.MunicipalityId)) ? [filters.municipality, ...(municipalities || [])] : (municipalities || [])}
            loading={loadingMunicipalities}
            isOptionEqualToValue={(option, value) => (option?.id || option?.MunicipalityId) == (value?.id || value?.MunicipalityId)}
            loadingText={t('GLOBAL.searching')}
            getOptionLabel={(option) => option?.name || option?.municipality_name || ""}

            onChange={(e, v, r) => {
              setFilters({
                ...filters,
                municipality: v,
                municipality_id: v ? v?.id : ""
              })
            }}
            renderInput={(params) => (
              <TextField {...params}
                placeholder={t('GLOBAL.municipalities')}
                variant="standard" sx={{ fontFamily: 'Cairo-Medium' }} />
            )}
          /></Gate>

          <Gate name="mizan_selected"><Autocomplete
            sx={{
              ml: 1.5, mt: 1, mb: 1, width: '95%',
              '& .MuiFormLabel-root,& .MuiInputBase-input': {
                fontFamily: 'Cairo-Medium'
              }
            }}
            value={filters?.mizan_selected || null}
            onChange={(e, v) => {
              setFilters({
                ...filters,
                mizan_id: v?.id || null,
                mizan_selected: v,
                is_internal: isInternal
              })
            }}
            options={filters?.mizan_selected && !lookups?.mizans.find(m => m.id == filters.mizan_selected.id) ? [filters.mizan_selected, ...lookups?.mizans] : (lookups?.mizans || [])}
            loading={loadingLookups}
            isOptionEqualToValue={(option, value) => option?.id == value?.id}
            loadingText={t('GLOBAL.searching')}
            getOptionLabel={(option) => option && option?.name || ""}
            renderInput={(params) => (
              <TextField {...params}
                placeholder={t('MIZAN_UNITS.mizan') || 'الميزان'}
                variant="standard" sx={{ fontFamily: 'Cairo-Medium' }} />
            )}
          /></Gate>




        </>
      }

      <Gate name="unit_type_selected"><Autocomplete
        sx={{
          ml: 1.5, mt: 1, mb: 1, width: '95%',
          '& .MuiFormLabel-root,& .MuiInputBase-input': {
            fontFamily: 'Cairo-Medium'
          }
        }}
        value={filters?.unit_type_selected || null}
        onChange={(e, v) => {
          setFilters({
            ...filters,
            unit_type_id: v?.id || null,
            unit_type_selected: v
          })
        }}
        options={lookups?.unit_types || []}
        loading={loadingLookups}
        loadingText={t('GLOBAL.searching')}
        getOptionLabel={(option) => option && option?.name ? option?.name : ""}
        isOptionEqualToValue={(option, value) => option?.id === value?.id}
        renderInput={(params) => (
          <TextField {...params}
            placeholder={t('MIZAN_UNITS.unit_type') || 'نوع المركبة'}
            variant="standard" sx={{ fontFamily: 'Cairo-Medium' }} />
        )}
      /></Gate>

      {!isInternal && (
        <Gate name="port_categories_selected"><Autocomplete
          sx={{
            ml: 1.5, mt: 1, mb: 1, width: '95%',
            '& .MuiFormLabel-root,& .MuiInputBase-input': {
              fontFamily: 'Cairo-Medium'
            }
          }}
          value={filters?.port_categories_selected ? filters?.port_categories_selected : []}
          options={portCategories?.length ? portCategories : []}
          multiple={true}
          loading={loadingPortCategories}
          isOptionEqualToValue={(option, value) => option?.id === value?.id}
          loadingText={t('GLOBAL.searching')}
          getOptionLabel={(option) => option && option?.name || ""}

          onChange={(e, v, r) => {
            setFilters({
              ...filters,
              port_category_ids: v?.length > 0 ? v?.map(port_category_id => port_category_id?.id) : [],
              port_categories_selected: v
            })
          }}
          renderInput={(params) => (
            <TextField {...params}
              placeholder={t('TRANSACTIONS.destination_port_categories')}
              variant="standard" sx={{ fontFamily: 'Cairo-Medium' }} />
          )}
        /></Gate>
      )}
      <Gate name="groups_selected"><Autocomplete
        sx={{
          ml: 1.5, mt: 1, mb: 1, width: '95%',
          '& .MuiFormLabel-root,& .MuiInputBase-input': {
            fontFamily: 'Cairo-Medium'
          }
        }}
        value={filters?.groups_selected ? filters?.groups_selected : []}
        options={groups?.length ? groups : []}
        multiple={true}
        loading={loadingGroups}
        isOptionEqualToValue={(option, value) => option?.id === value?.id}
        loadingText={t('GLOBAL.searching')}
        getOptionLabel={(option) => option && option?.name || ""}
        // Wialon groups from different resources can share the same name; MUI keys
        // options by label, and duplicate keys corrupt the listbox while filtering.
        renderOption={(props, option) => (
          <li {...props} key={option?.id}>
            {option?.name}
          </li>
        )}
        onChange={(e, v, r) => {
          setFilters({
            ...filters,
            group_ids: v?.length > 0 ? v?.map(group => group?.id) : [],
            groups_selected: v
          })
        }}
        renderInput={(params) => (
          <TextField {...params}
            placeholder={"المجاميع"}
            variant="standard" sx={{ fontFamily: 'Cairo-Medium' }} />
        )}
      /></Gate>
       <Gate name="sourceGeofence"><Autocomplete
        sx={{
          ml: 1.5, mt: 1, mb: 1, width: '95%',
          '& .MuiFormLabel-root,& .MuiInputBase-input': {
            fontFamily: 'Cairo-Medium'
          }
        }}
        onInputChange={(event, newInputValue) => {

          // handleSearchTermSourceGeofenceChange(newInputValue);
        }}

        loading={loadingSourceGeofences}
        isOptionEqualToValue={(option, value) => option?.id == value?.id}
        loadingText={t('GLOBAL.searching')}
        value={filters?.sourceGeofence}
        options={filters?.sourceGeofence && !sourceGeofences.find(s => s.id == filters.sourceGeofence.id) ? [filters.sourceGeofence, ...sourceGeofences] : (sourceGeofences || [])}
        getOptionLabel={(option) => {

          return option && option?.name || ""
        }}
        onChange={(e, v, r) => {

          setFilters({
            ...filters,
            sourceGeofence: v,
            source_geofence_id: v ? v?.id : ""
          })
        }}
        renderInput={(params) => (
          <TextField {...params}
            placeholder={isInternal ? t('TRANSACTIONS.destination_geofence') : t('TRANSACTIONS.source_geofence')}
            variant="standard" sx={{ fontFamily: 'Cairo-Medium' }} />
        )}
      /></Gate>
      <Gate name="host_mizan_selected"><Autocomplete
        sx={{
          ml: 1.5, mt: 1, mb: 1, width: '95%',
          '& .MuiFormLabel-root,& .MuiInputBase-input': {
            fontFamily: 'Cairo-Medium'
          }
        }}
        value={filters?.host_mizan_selected || null}
        onChange={(e, v) => {
          setFilters({
            ...filters,
            host_mizan_id: v?.id || null,
            host_mizan_selected: v,
            is_internal: isInternal
          })
        }}
        options={filters?.host_mizan_selected && !lookups?.mizans.find(m => m.id == filters.host_mizan_selected.id) ? [filters.host_mizan_selected, ...lookups?.mizans] : (lookups?.mizans || [])}
        loading={loadingLookups}
        isOptionEqualToValue={(option, value) => option?.id == value?.id}
        loadingText={t('GLOBAL.searching')}
        getOptionLabel={(option) => option && option?.name || ""}
        renderInput={(params) => (
          <TextField {...params}
            placeholder={t('TRANSACTIONS.host_mizan') || 'الميزان المستضاف'}
            variant="standard" sx={{ fontFamily: 'Cairo-Medium' }} />
        )}
      /></Gate>
       <Gate name="hostingSourceGeofence"><Autocomplete
        sx={{
          ml: 1.5, mt: 1, mb: 1, width: '95%',
          '& .MuiFormLabel-root,& .MuiInputBase-input': {
            fontFamily: 'Cairo-Medium'
          }
        }}
        onInputChange={(event, newInputValue) => {

          //handleSearchTermHostingSourceGeofenceChange(newInputValue);
        }}
        //inputValue={searchTermHostingSourceGeofence}
        loading={loadingHostingSourceGeofences}
        isOptionEqualToValue={(option, value) => option?.id == value?.id}
        loadingText={t('GLOBAL.searching')}
        value={filters?.hostingSourceGeofence || null}
        options={filters?.hostingSourceGeofence && !hostingSourceGeofences.find(h => h.id == filters.hostingSourceGeofence.id) ? [filters.hostingSourceGeofence, ...hostingSourceGeofences] : (hostingSourceGeofences || [])}
        getOptionLabel={(option) => {

          return option && option?.name || ""
        }}
        onChange={(e, v, r) => {

          setFilters({
            ...filters,
            hostingSourceGeofence: v,
            hosting_source_geofence_id: v ? v?.id : ""
          })
        }}
        renderInput={(params) => (
          <TextField {...params}
            placeholder={t('TRANSACTIONS.hosting_source_geofence_name', 'نقطة التحميل المستضافة')}
            variant="standard" sx={{ fontFamily: 'Cairo-Medium' }} />
        )}
      /></Gate>
      {!isInternal && (
        <Gate name="destinationGeofence"><Autocomplete
          sx={{
            ml: 1.5, mt: 1, mb: 1, width: '95%',
            '& .MuiFormLabel-root,& .MuiInputBase-input': {
              fontFamily: 'Cairo-Medium'
            }
          }}
          onInputChange={(event, newInputValue) => {

            //handleSearchTermDestinationGeofenceChange(newInputValue);
          }}
          //inputValue={searchTermDestinationGeofence}
          loading={loadingDestinationGeofences}
          isOptionEqualToValue={(option, value) => option?.id == value?.id}
          loadingText={t('GLOBAL.searching')}
          value={filters?.destinationGeofence}
          options={filters?.destinationGeofence && !destinationGeofences.find(d => d.id == filters.destinationGeofence.id) ? [filters.destinationGeofence, ...destinationGeofences] : (destinationGeofences || [])}

          getOptionLabel={(option) => {

            return option && option?.name || ""
          }}



          onChange={(e, v, r) => {

            setFilters({
              ...filters,
              destinationGeofence: v,
              destination_geofence_id: v ? v?.id : ""
            })
          }}
          renderInput={(params) => (
            <TextField {...params}
              placeholder={t('TRANSACTIONS.destination_geofence')}
              variant="standard" sx={{ fontFamily: 'Cairo-Medium' }} />
          )}
        /></Gate>
      )}
      <Gate name="creationDate"><CustomDateRange
        title={'وقت اصدار المستند'}
        showAllTime={false}
        showTitle={true}
        dateRange={filters}
        setDateRange={(value) => {
          setFilters({
            ...filters,
            ...value
          })
        }}
      /></Gate>

      {!isInternal ?
        <>
          <CustomDateRange
            title={t('TRANSACTIONS.arrived_at')}
            showTitle={true}
            dateRange={{
              creationDateFrom: filters?.arrivedAtDateFrom,
              creation_date_from: filters?.arrived_at_date_from,
              creationDateTo: filters?.arrivedAtDateTo,
              creation_date_to: filters?.arrived_at_date_to,
              all_time: filters?.all_time_arrived_at
            }}
            setDateRange={(value) => {
              setFilters({
                ...filters,
                arrivedAtDateFrom: value?.creationDateFrom,
                arrived_at_date_from: value?.creation_date_from,
                arrivedAtDateTo: value?.creationDateTo,
                arrived_at_date_to: value?.creation_date_to,
                all_time_arrived_at: value?.all_time

              })
            }}
          />
          <SearchInput
            value={filters?.transaction_id}
            setValue={(value) => {
              if (!isNaN(value)) {
                setFilters({
                  ...filters,
                  transaction_id: value
                })
              }

            }}
            title={"#"}
          />

        </> : null}
      <Gate name="transaction_number"><SearchInput
        value={filters?.transaction_number}
        setValue={(value) => {

          setFilters({
            ...filters,
            transaction_number: value
          })


        }}
        title={t('TRANSACTIONS.transaction_number')}
      /></Gate>
      {showWeightRange && <Gate name="weight_range"><Box sx={{ width: '100%' }}>
        <Typography sx={{ fontFamily: 'Cairo-Medium', fontSize: '14px', ml: 1.5, mt: 1 }}>
          مدى الوزن (طن)
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
          <Box sx={{ flex: 1 }}>
            <SearchInput
              value={filters?.min_weight}
              setValue={(value) => {
                if (!isNaN(value)) {
                  setFilters({
                    ...filters,
                    min_weight: value
                  })
                }
              }}
              title={"أدنى وزن"}
            />
          </Box>
          <Box sx={{ flex: 1 }}>
            <SearchInput
              value={filters?.max_weight}
              setValue={(value) => {
                if (!isNaN(value)) {
                  setFilters({
                    ...filters,
                    max_weight: value
                  })
                }
              }}
              title={"أقصى وزن"}
            />
          </Box>
        </Box>
      </Box></Gate>}
      {!isInternal && (
        <>
          {noUnits ?
            <>
              <SearchInput
                value={filters?.unit_registration_number}
                setValue={(value) => {
                  setFilters({
                    ...filters,
                    unit_registration_number: value
                  })
                }}
                title={t('TRANSACTIONS.unit_registration_number')}
              />
              <SearchInput
                value={filters?.driver_name}
                setValue={(value) => {
                  setFilters({
                    ...filters,
                    driver_name: value
                  })
                }}
                title={t('TRANSACTIONS.driver_name')}
              />
            </> :
            <>
              {/* <Autocomplete
                sx={{
                  ml: 1.5, mt: 1, mb: 1, width: '95%',
                  '& .MuiFormLabel-root,& .MuiInputBase-input': {
                    fontFamily: 'Cairo-Medium'
                  }
                }}
                value={filters?.unit_monitored_by_id_selected ? filters?.unit_monitored_by_id_selected : []}
                options={users?.length ? users : []}
                multiple={true}
                loading={loadingUsers}
                loadingText={t('GLOBAL.searching')}
                getOptionLabel={(option) => option && option?.name || ""}

                onChange={(e, v, r) => {
                  setFilters({
                    ...filters,
                    unit_monitored_by_ids: v?.length > 0 ? v?.map(user => user?.id) : [],
                    unit_monitored_by_id_selected: v
                  })
                }}
                renderInput={(params) => (
                  <TextField {...params}
                    placeholder={t('TRANSACTIONS.unit_monitored_by_name_formatted')}
                    variant="standard" sx={{ fontFamily: 'Cairo-Medium' }} />
                )}
              /> */}
            </>
          }
          <Gate name="auditedByName"><Autocomplete
            sx={{
              ml: 1.5, mt: 1, mb: 1, width: '95%',
              '& .MuiFormLabel-root,& .MuiInputBase-input': {
                fontFamily: 'Cairo-Medium'
              }
            }}

            loading={loadingUsers}
            loadingText={t('GLOBAL.searching')}
            value={filters?.auditedByName}
            options={users}
            getOptionLabel={(option) => {

              return option && option?.name || ""
            }}
            onChange={(e, v, r) => {

              setFilters({
                ...filters,
                auditedByName: v,
                audited_by_name: v ? v?.name : ""
              })
            }}
            renderInput={(params) => (
              <TextField {...params}
                placeholder={t('TRANSACTIONS.audited_by_name')}
                variant="standard" sx={{ fontFamily: 'Cairo-Medium' }} />
            )}
          /></Gate>

          <Gate name="note"><SearchInput
            value={filters?.note}
            setValue={(value) => {
              setFilters({
                ...filters,
                note: value
              })
            }}
            title={t('TRANSACTIONS.search_in_notes')}
          /></Gate>
          {/* <SearchInput
            value={filters?.destination_warehouse}
            setValue={(value) => {
              setFilters({
                ...filters,
                destination_warehouse: value
              })
            }}
            title={t('TRANSACTIONS.search_destination_geofence_name')}
          /> */}

          <Gate name="transaction_status_selected"><Autocomplete
            sx={{
              ml: 1.5, mt: 1, mb: 1, width: '95%',
              '& .MuiFormLabel-root,& .MuiInputBase-input': {
                fontFamily: 'Cairo-Medium'
              }
            }}
            value={filters?.transaction_status_selected ? filters?.transaction_status_selected : []}
            options={transactionStatuses?.length ? transactionStatuses : []}
            multiple={true}
            loading={loadingTransactionStatuses}
            isOptionEqualToValue={(option, value) => option?.id == value?.id}
            loadingText={t('GLOBAL.searching')}
            getOptionLabel={(option) => option && option?.name || ""}

            onChange={(e, v, r) => {
              setFilters({
                ...filters,
                transaction_status_ids: v?.length > 0 ? v?.map(transaction_status => transaction_status?.id) : [],
                transaction_status_selected: v
              })
            }}
            renderInput={(params) => (
              <TextField {...params}
                placeholder={t('TRANSACTIONS.transaction_statuses')}
                variant="standard" sx={{ fontFamily: 'Cairo-Medium' }} />
            )}
          /></Gate>
        </>
      )}

      {/* <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
        }}
      >

        <Box
          sx={{
            backgroundColor: "lightgray",
            display: "flex",
            flexDirection: 'column',
            alignItems: "center",
            justifyContent: "start",
            ml: 1.5,
            mt: 1,
            mb: 1,
            width: "100%",
            "& .MuiTypography-root": {
              fontFamily: "Cairo",
            },
          }}
          className="px-2 rounded"
        >
          <Typography>
            {t('TRANSACTIONS.branches_general')}
          </Typography>
          <Autocomplete
            sx={{
              ml: 1.5, mt: 1, mb: 1, width: '95%',
              '& .MuiFormLabel-root,& .MuiInputBase-input': {
                fontFamily: 'Cairo-Medium'
              }
            }}
            value={filters?.branches_selected ? filters?.branches_selected : []}
            options={branches?.length ? branches : []}
            multiple={true}
            loading={loadingBranches}
            loadingText={t('GLOBAL.searching')}
            getOptionLabel={(option) => option && option?.name || ""}

            onChange={(e, v, r) => {
              setFilters({
                ...filters,
                branch_ids: v?.length > 0 ? v?.map(branch => branch?.id) : [],
                branches_selected: v
              })
            }}
            renderInput={(params) => (
              <TextField {...params}
                placeholder={t('TRANSACTIONS.branches_general')}
                variant="standard" sx={{ fontFamily: 'Cairo-Medium' }} />
            )}
          />

          <RadioGroup
            row={false}
            sx={{
              width: "100%",
              "& .MuiTypography-root": {
                fontFamily: "Cairo",
              },
            }}
            value={filters?.branch_type}
            onChange={(e) => {
              setFilters({
                ...filters,
                branch_type: e?.target.value
              })

            }}
          >
            <FormControlLabel
              value={1}
              control={<Radio sx={{ fontFamily: "Cairo" }} />}
              label={t("TRANSACTIONS.source_branch")}
            />
            <FormControlLabel
              value={0}
              control={<Radio sx={{ fontFamily: "Cairo" }} />}
              label={t("TRANSACTIONS.destination_branch")}
            />
            <FormControlLabel
              value={-1}
              control={<Radio sx={{ fontFamily: "Cairo" }} />}
              label={t("TRANSACTIONS.all")}
            />


          </RadioGroup>
        </Box>
      </Box> */}


      {/*       
      <Autocomplete
        sx={{
          ml: 1.5, mt: 1, mb: 1, width: '95%',
          '& .MuiFormLabel-root,& .MuiInputBase-input': {
            fontFamily: 'Cairo-Medium'
          }
        }}

        loading={loadingTransactionProductTypes}
        loadingText={t('GLOBAL.searching')}
        value={filters?.productType}
        options={transactionProductTypes}
        getOptionLabel={(option) => {

          return option && option?.name || ""
        }}
        onChange={(e, v, r) => {

          setFilters({
            ...filters,
            productType: v,
            product_type_id: v ? v?.id : ""
          })
        }}
        renderInput={(params) => (
          <TextField {...params}
            placeholder={t('TRANSACTIONS.product_type')}
            variant="standard" sx={{ fontFamily: 'Cairo-Medium' }} />
        )}
      /> */}

      {/* <Autocomplete
        sx={{
          ml: 1.5, mt: 1, mb: 1, width: '95%',
          '& .MuiFormLabel-root,& .MuiInputBase-input': {
            fontFamily: 'Cairo-Medium'
          }
        }}
        onInputChange={(event, newInputValue) => {

          handleSearchTermRouteChange(newInputValue);
        }}
        inputValue={searchTermRoute}
        loading={loadingRoutes}
        loadingText={t('GLOBAL.searching')}
        value={filters?.route}
        options={routes}

        getOptionLabel={(option) => {

          return option && option?.name || ""
        }}



        onChange={(e, v, r) => {

          setFilters({
            ...filters,
            route: v,
            route_id: v ? v?.id : ""
          })
        }}
        renderInput={(params) => (
          <TextField {...params}
            placeholder={t('TRANSACTIONS.route')}
            variant="standard" sx={{ fontFamily: 'Cairo-Medium' }} />
        )}
      /> */}
      {/* {showUnitTransactionType ? null : */}

      {/* } */}


      {showType ? <Box
        sx={{
          display: "flex",

          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
        }}
      >

        <Box
          sx={{
            backgroundColor: "lightgray",
            display: "flex",
            flexDirection: 'column',
            alignItems: "center",
            justifyContent: "start",
            ml: 1.5,
            mt: 1,
            mb: 1,
            width: "100%",
            "& .MuiTypography-root": {
              fontFamily: "Cairo",
            },
          }}
          className="px-2 rounded"
        >
          <Typography>
            {t('TRANSACTIONS.carrier')}
          </Typography>

          <RadioGroup
            row={false}
            sx={{
              width: "100%",
              "& .MuiTypography-root": {
                fontFamily: "Cairo",
              },
            }}
            value={filters?.carrier}
            onChange={(e) => {
              setFilters({
                ...filters,
                carrier: e?.target.value
              })

            }}
          >
            <FormControlLabel
              value={1}
              control={<Radio sx={{ fontFamily: "Cairo" }} />}
              label={t("TRANSACTIONS.carrier_governmental")}
            />
            <FormControlLabel
              value={0}
              control={<Radio sx={{ fontFamily: "Cairo" }} />}
              label={t("TRANSACTIONS.carrier_private")}
            />
            <FormControlLabel
              value={-1}
              control={<Radio sx={{ fontFamily: "Cairo" }} />}
              label={t("TRANSACTIONS.all")}
            />


          </RadioGroup>
        </Box>
      </Box> : null}

      <Gate name="weight_problem"><Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Box
          sx={{
            backgroundColor: "lightgray",
            display: "flex",
            flexDirection: 'column',
            alignItems: "center",
            justifyContent: "start",
            ml: 1.5,
            mt: 1,
            mb: 1,
            width: "100%",
            "& .MuiTypography-root": {
              fontFamily: "Cairo",
            },
          }}
          className="px-2 rounded"
        >
          <Typography>
            {"مشاكل الاوزان"}
          </Typography>

          <RadioGroup
            row={false}
            sx={{
              width: "100%",
              "& .MuiTypography-root": {
                fontFamily: "Cairo",
              },
            }}
            value={filters?.weight_problem?.toString() ?? "-1"}
            onChange={(e) => {
              setFilters({
                ...filters,
                weight_problem: e?.target.value
              })
            }}
          >
            <FormControlLabel
              value={"1"}
              control={<Radio sx={{ fontFamily: "Cairo" }} />}
              label="يوجد مشكلة بالوزن"
            />
            <FormControlLabel
              value={"-1"}
              control={<Radio sx={{ fontFamily: "Cairo" }} />}
              label={t("TRANSACTIONS.all")}
            />
          </RadioGroup>
        </Box>
      </Box></Gate>

      {(noUnits || isInternal) ? null : <>

        {/* <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >

          <Box
            sx={{
              backgroundColor: "lightgray",
              display: "flex",
              flexDirection: 'column',
              alignItems: "center",
              justifyContent: "start",
              ml: 1.5,
              mt: 1,
              mb: 1,
              width: "100%",
              "& .MuiTypography-root": {
                fontFamily: "Cairo",
              },
            }
            className="px-2 rounded"
          >
            <Typography>
              {t('TRANSACTIONS.unit_is_monitored')}
            </Typography>

            <RadioGroup
              row={false}
              sx={{
                width: "100%",
                "& .MuiTypography-root": {
                  fontFamily: "Cairo",
                },
              }}
              value={filters?.unit_is_monitored}
              onChange={(e) => {
                setFilters({
                  ...filters,
                  unit_is_monitored: e?.target.value
                })

              }}
            >
              <FormControlLabel
                value={1}
                control={<Radio sx={{ fontFamily: "Cairo" }} />}
                label={t("TRANSACTIONS.unit_is_monitored")}
              />
              <FormControlLabel
                value={0}
                control={<Radio sx={{ fontFamily: "Cairo" }} />}
                label={t("TRANSACTIONS.unit_is_not_monitored")}
              />
              <FormControlLabel
                value={-1}
                control={<Radio sx={{ fontFamily: "Cairo" }} />}
                label={t("TRANSACTIONS.all")}
              />


            </RadioGroup>
          </Box>
        </Box> */}

        <Gate name="is_monitored"><Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >

          <Box
            sx={{
              backgroundColor: "lightgray",
              display: "flex",
              flexDirection: 'column',
              alignItems: "center",
              justifyContent: "start",
              ml: 1.5,
              mt: 1,
              mb: 1,
              width: "100%",
              "& .MuiTypography-root": {
                fontFamily: "Cairo",
              },
            }}
            className="px-2 rounded"
          >
            <Typography>
              {t('TRANSACTIONS.is_monitored')}
            </Typography>

            <RadioGroup
              row={false}
              sx={{
                width: "100%",
                "& .MuiTypography-root": {
                  fontFamily: "Cairo",
                },
              }}
              value={filters?.is_monitored}
              onChange={(e) => {
                setFilters({
                  ...filters,
                  is_monitored: e?.target.value
                })

              }}
            >
              <FormControlLabel
                value={1}
                control={<Radio sx={{ fontFamily: "Cairo" }} />}
                label={t("TRANSACTIONS.monitored")}
              />
              <FormControlLabel
                value={0}
                control={<Radio sx={{ fontFamily: "Cairo" }} />}
                label={t("TRANSACTIONS.not_monitored")}
              />
              <FormControlLabel
                value={-1}
                control={<Radio sx={{ fontFamily: "Cairo" }} />}
                label={t("TRANSACTIONS.all")}
              />


            </RadioGroup>
          </Box>
        </Box></Gate>

        <Gate name="arrival_validity"><Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >

          <Box
            sx={{
              backgroundColor: "lightgray",
              display: "flex",
              flexDirection: 'column',
              alignItems: "center",
              justifyContent: "start",
              ml: 1.5,
              mt: 1,
              mb: 1,
              width: "100%",
              "& .MuiTypography-root": {
                fontFamily: "Cairo",
              },
            }}
            className="px-2 rounded"
          >
            <Typography>
              {t('TRANSACTIONS.arrival_valid')}
            </Typography>

            <RadioGroup
              row={false}
              sx={{
                width: "100%",
                "& .MuiTypography-root": {
                  fontFamily: "Cairo",
                },
              }}
              value={filters?.arrival_validity}
              onChange={(e) => {
                setFilters({
                  ...filters,
                  arrival_validity: e?.target.value
                })

              }}
            >
              <FormControlLabel
                value={1}
                control={<Radio sx={{ fontFamily: "Cairo" }} />}
                label={t("TRANSACTIONS.arrival_valid_true")}
              />
              <FormControlLabel
                value={0}
                control={<Radio sx={{ fontFamily: "Cairo" }} />}
                label={t("TRANSACTIONS.arrival_valid_false")}
              />
              <FormControlLabel
                value={-1}
                control={<Radio sx={{ fontFamily: "Cairo" }} />}
                label={t("TRANSACTIONS.all")}
              />


            </RadioGroup>
          </Box>
        </Box></Gate>

        <Gate name="has_violation"><Box
          sx={{
            display: "flex",

            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >

          <Box
            sx={{
              backgroundColor: "lightgray",
              display: "flex",
              flexDirection: 'column',
              alignItems: "center",
              justifyContent: "start",
              ml: 1.5,
              mt: 1,
              mb: 1,
              width: "100%",
              "& .MuiTypography-root": {
                fontFamily: "Cairo",
              },
            }}
            className="px-2 rounded"
          >
            <Typography>
              {t('TRANSACTIONS.has_violation')}
            </Typography>

            <RadioGroup
              row={false}
              sx={{
                width: "100%",
                "& .MuiTypography-root": {
                  fontFamily: "Cairo",
                },
              }}
              value={filters?.has_violation}
              onChange={(e) => {
                setFilters({
                  ...filters,
                  has_violation: e?.target.value
                })

              }}
            >
              <FormControlLabel
                value={1}
                control={<Radio sx={{ fontFamily: "Cairo" }} />}
                label={t("TRANSACTIONS.has_violation")}
              />
              <FormControlLabel
                value={0}
                control={<Radio sx={{ fontFamily: "Cairo" }} />}
                label={t("TRANSACTIONS.doesnt_has_violation")}
              />
              <FormControlLabel
                value={-1}
                control={<Radio sx={{ fontFamily: "Cairo" }} />}
                label={t("TRANSACTIONS.all")}
              />


            </RadioGroup>
          </Box>
        </Box></Gate>

        <Gate name="is_complete"><Box
          sx={{
            display: "flex",

            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >

          <Box
            sx={{
              backgroundColor: "lightgray",
              display: "flex",
              flexDirection: 'column',
              alignItems: "center",
              justifyContent: "start",
              ml: 1.5,
              mt: 1,
              mb: 1,
              width: "100%",
              "& .MuiTypography-root": {
                fontFamily: "Cairo",
              },
            }}
            className="px-2 rounded"
          >
            <Typography>
              {t('TRANSACTIONS.is_complete')}
            </Typography>

            <RadioGroup
              row={false}
              sx={{
                width: "100%",
                "& .MuiTypography-root": {
                  fontFamily: "Cairo",
                },
              }}
              value={filters?.is_complete}
              onChange={(e) => {
                setFilters({
                  ...filters,
                  is_complete: e?.target.value
                })

              }}
            >
              <FormControlLabel
                value={1}
                control={<Radio sx={{ fontFamily: "Cairo" }} />}
                label={t("TRANSACTIONS.is_complete")}
              />
              <FormControlLabel
                value={0}
                control={<Radio sx={{ fontFamily: "Cairo" }} />}
                label={t("TRANSACTIONS.not_complete")}
              />
              <FormControlLabel
                value={-1}
                control={<Radio sx={{ fontFamily: "Cairo" }} />}
                label={t("TRANSACTIONS.all")}
              />


            </RadioGroup>
          </Box>
        </Box></Gate>

        <Gate name="exceeded_allowed_time"><Box
          sx={{
            display: "flex",

            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >

          <Box
            sx={{
              backgroundColor: "lightgray",
              display: "flex",
              flexDirection: 'column',
              alignItems: "center",
              justifyContent: "start",
              ml: 1.5,
              mt: 1,
              mb: 1,
              width: "100%",
              "& .MuiTypography-root": {
                fontFamily: "Cairo",
              },
            }}
            className="px-2 rounded"
          >
            <Typography>
              {t('TRANSACTIONS.exceeded_allowed_time')}
            </Typography>

            <RadioGroup
              row={false}
              sx={{
                width: "100%",
                "& .MuiTypography-root": {
                  fontFamily: "Cairo",
                },
              }}
              value={filters?.exceeded_allowed_time}
              onChange={(e) => {
                setFilters({
                  ...filters,
                  exceeded_allowed_time: e?.target.value
                })

              }}
            >
              <FormControlLabel
                value={1}
                control={<Radio sx={{ fontFamily: "Cairo" }} />}
                label={t("TRANSACTIONS.exceeded_allowed_time")}
              />
              <FormControlLabel
                value={0}
                control={<Radio sx={{ fontFamily: "Cairo" }} />}
                label={t("TRANSACTIONS.not_exceeded_allowed_time")}
              />
              <FormControlLabel
                value={-1}
                control={<Radio sx={{ fontFamily: "Cairo" }} />}
                label={t("TRANSACTIONS.all")}
              />


            </RadioGroup>
          </Box>
        </Box></Gate>


        <Gate name="has_stop_violation"><Box
          sx={{
            display: "flex",

            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >

          <Box
            sx={{
              backgroundColor: "lightgray",
              display: "flex",
              flexDirection: 'column',
              alignItems: "center",
              justifyContent: "start",
              ml: 1.5,
              mt: 1,
              mb: 1,
              width: "100%",
              "& .MuiTypography-root": {
                fontFamily: "Cairo",
              },
            }}
            className="px-2 rounded"
          >
            <Typography>
              {t('TRANSACTIONS.has_stop_violation')}
            </Typography>

            <RadioGroup
              row={false}
              sx={{
                width: "100%",
                "& .MuiTypography-root": {
                  fontFamily: "Cairo",
                },
              }}
              value={filters?.has_stop_violation}
              onChange={(e) => {
                setFilters({
                  ...filters,
                  has_stop_violation: e?.target.value
                })

              }}
            >
              <FormControlLabel
                value={1}
                control={<Radio sx={{ fontFamily: "Cairo" }} />}
                label={t("TRANSACTIONS.has_stop_violation")}
              />
              <FormControlLabel
                value={0}
                control={<Radio sx={{ fontFamily: "Cairo" }} />}
                label={t("TRANSACTIONS.doesnt_have_stop_violation")}
              />
              <FormControlLabel
                value={-1}
                control={<Radio sx={{ fontFamily: "Cairo" }} />}
                label={t("TRANSACTIONS.all")}
              />


            </RadioGroup>
          </Box>
        </Box></Gate>

        <Gate name="valid"><Box
          sx={{
            display: "flex",

            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >

          <Box
            sx={{
              backgroundColor: "lightgray",
              display: "flex",
              flexDirection: 'column',
              alignItems: "center",
              justifyContent: "start",
              ml: 1.5,
              mt: 1,
              mb: 1,
              width: "100%",
              "& .MuiTypography-root": {
                fontFamily: "Cairo",
              },
            }}
            className="px-2 rounded"
          >
            <Typography>
              {t('TRANSACTIONS.valid')}
            </Typography>

            <RadioGroup
              row={false}
              sx={{
                width: "100%",
                "& .MuiTypography-root": {
                  fontFamily: "Cairo",
                },
              }}
              value={filters?.valid}
              onChange={(e) => {
                setFilters({
                  ...filters,
                  valid: e?.target.value
                })

              }}
            >
              <FormControlLabel
                value={1}
                control={<Radio sx={{ fontFamily: "Cairo" }} />}
                label={t("TRANSACTIONS.valid")}
              />
              <FormControlLabel
                value={0}
                control={<Radio sx={{ fontFamily: "Cairo" }} />}
                label={t("TRANSACTIONS.not_valid")}
              />
              <FormControlLabel
                value={-1}
                control={<Radio sx={{ fontFamily: "Cairo" }} />}
                label={t("TRANSACTIONS.all")}
              />


            </RadioGroup>
          </Box>
        </Box></Gate>

        <Gate name="destination_mismatch"><Box
          sx={{
            display: "flex",

            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >

          <Box
            sx={{
              backgroundColor: "lightgray",
              display: "flex",
              flexDirection: 'column',
              alignItems: "center",
              justifyContent: "start",
              ml: 1.5,
              mt: 1,
              mb: 1,
              width: "100%",
              "& .MuiTypography-root": {
                fontFamily: "Cairo",
              },
            }}
            className="px-2 rounded"
          >
            <Typography>
              {t('TRANSACTIONS.destination_mismatch_filter')}
            </Typography>

            <RadioGroup
              row={false}
              sx={{
                width: "100%",
                "& .MuiTypography-root": {
                  fontFamily: "Cairo",
                },
              }}
              value={filters?.destination_mismatch}
              onChange={(e) => {
                setFilters({
                  ...filters,
                  destination_mismatch: e?.target.value
                })

              }}
            >
              <FormControlLabel
                value={1}
                control={<Radio sx={{ fontFamily: "Cairo" }} />}
                label={t("TRANSACTIONS.destination_mismatch_yes")}
              />
              <FormControlLabel
                value={0}
                control={<Radio sx={{ fontFamily: "Cairo" }} />}
                label={t("TRANSACTIONS.destination_mismatch_no")}
              />
              <FormControlLabel
                value={-1}
                control={<Radio sx={{ fontFamily: "Cairo" }} />}
                label={t("TRANSACTIONS.all")}
              />


            </RadioGroup>
          </Box>
        </Box></Gate>

        <Gate name="audited_by_type"><Box
          sx={{
            display: "flex",

            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >

          <Box
            sx={{
              backgroundColor: "lightgray",
              display: "flex",
              flexDirection: 'column',
              alignItems: "center",
              justifyContent: "start",
              ml: 1.5,
              mt: 1,
              mb: 1,
              width: "100%",
              "& .MuiTypography-root": {
                fontFamily: "Cairo",
              },
            }}
            className="px-2 rounded"
          >
            <Typography>
              {t('TRANSACTIONS.audited_by_type_filter')}
            </Typography>

            <RadioGroup
              row={false}
              sx={{
                width: "100%",
                "& .MuiTypography-root": {
                  fontFamily: "Cairo",
                },
              }}
              value={filters?.audited_by_type ? filters?.audited_by_type : 'all'}
              onChange={(e) => {
                setFilters({
                  ...filters,
                  audited_by_type: e?.target.value
                })

              }}
            >
              <FormControlLabel
                value={'all'}
                control={<Radio sx={{ fontFamily: "Cairo" }} />}
                label={t("TRANSACTIONS.all")}
              />
              <FormControlLabel
                value={'system'}
                control={<Radio sx={{ fontFamily: "Cairo" }} />}
                label={t("TRANSACTIONS.audited_by_type_system")}
              />
              <FormControlLabel
                value={'user'}
                control={<Radio sx={{ fontFamily: "Cairo" }} />}
                label={t("TRANSACTIONS.audited_by_type_user")}
              />


            </RadioGroup>
          </Box>
        </Box></Gate>

        {showUnitTransactionType ?
          <Box
            sx={{
              display: "flex",

              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >

            <Box
              sx={{
                backgroundColor: "lightgray",
                display: "flex",
                flexDirection: 'column',
                alignItems: "center",
                justifyContent: "start",
                ml: 1.5,
                mt: 1,
                mb: 1,
                width: "100%",
                "& .MuiTypography-root": {
                  fontFamily: "Cairo",
                },
              }}
              className="px-2 rounded"
            >
              <Typography>
                {t('TRANSACTIONS.unit_transaction_type')}
              </Typography>

              <RadioGroup
                row={false}
                sx={{
                  width: "100%",
                  "& .MuiTypography-root": {
                    fontFamily: "Cairo",
                  },
                }}
                value={filters?.unit_transaction_type}
                onChange={(e) => {
                  setFilters({
                    ...filters,
                    unit_transaction_type: e?.target.value
                  })

                }}
              >
                <FormControlLabel
                  value={1}
                  control={<Radio sx={{ fontFamily: "Cairo" }} />}
                  label={t("UNITS.inside_baghdad")}
                />
                <FormControlLabel
                  value={0}
                  control={<Radio sx={{ fontFamily: "Cairo" }} />}
                  label={t("UNITS.outside_baghdad")}
                />
                <FormControlLabel
                  value={2}
                  control={<Radio sx={{ fontFamily: "Cairo" }} />}
                  label={t("UNITS.unknown")}
                />
                <FormControlLabel
                  value={-1}
                  control={<Radio sx={{ fontFamily: "Cairo" }} />}
                  label={t("UNITS.all")}
                />


              </RadioGroup>
            </Box>
          </Box> : null}
      </>}
    </Box>
  );
};

export default Search